/*
 * Roadhouse Quick-Add für Produktkarten
 * Eigenentwicklung (Okt 2026). Stellt window.addProductFromCollection bereit,
 * das von snippets/card-product.liquid aufgerufen wird.
 *
 * Ablauf: Variante per Cart-AJAX-API hinzufügen, Cart-Drawer + Warenkorb-Badge
 * über die Section Rendering API aktualisieren und den Drawer öffnen.
 * Fallback ohne Drawer: Weiterleitung zum Warenkorb.
 */
(function () {
  'use strict';

  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.disabled = busy;
    button.classList.toggle('is-loading', busy);
  }

  window.addProductFromCollection = function (variantId, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var button = event && event.currentTarget;
    if (button && button.getAttribute('aria-busy') === 'true') return;

    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer
        .getSectionsToRender()
        .map(function (section) { return section.id; })
        .join(',');
      body.sections_url = window.location.pathname;
      if (button && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }
    }

    setBusy(button, true);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // Unikate: meist "bereits im Warenkorb" oder ausverkauft.
          // Warenkorb zeigen statt stiller Fehler.
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(button);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          return;
        }

        if (cartDrawer && result.data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(result.data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'roadhouse-quick-add',
            productVariantId: variantId,
            cartData: result.data
          });
        }
      })
      .catch(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        setBusy(button, false);
      });
  };
})();
